export default __webpack_public_path__ + "static/media/aad7a566ce16b38eeb7c96e951b80d1f1579030321013.241fc13b.webp";